<template>
    <main class="layout">
        <l-header></l-header>
        <transition name="fade">
            <router-view>

            </router-view>
        </transition>
        <l-footer :about="about"></l-footer>
    </main>
</template>

<script>
import lHeader from "./header";
import lFooter from "./footer";

export default {
  name: "Layout",
  beforeRouteEnter(to, from, next){
  	next( _this  => {
        _this.about = _this.$route.name === 'Index';
    });
  	next();
  },
  beforeRouteUpdate(to, from, next){
      this.about = to.name === 'Index';
      next();
  },
  data(){
      return {
          about: false,
      }
  },
  components: {
    lHeader,
    lFooter
  },
  mounted(){
      this.$store.commit('CHANGE_PROGRESS', {progressBarShow: false, currentPercent: 0, nextPercent: 0});
  }

};
</script>

<style lang="scss">
.fade-enter-active {
    transition: opacity .5s;
}
.fade-enter{
    opacity: 0;
}
.fade-leave-active{
    display: none;
}
.fade-leave-to{
    display: none;
}
.layout{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .content{
        flex: 1;
    }
}
@media screen and (max-width: 1024px) {
    .content{
        padding-top: 48px;
    }

}

</style>
